import type { SportDetails } from '../api'
import { stateName } from './stateNames'

// Read-only approvals widget for the embed page. Shows where the sport is
// approved — US states + international regions. Phase 1 is inline-only;
// phase 2 will expose this same component as a standalone embeddable
// widget via the SDK.

interface Props {
  sport: SportDetails | null
  loading?: boolean
}

export default function ApprovalsWidget({ sport, loading = false }: Props) {
  if (loading) {
    return <p className="b-mono-dim ad-list-empty">LOADING…</p>
  }
  if (!sport) {
    return <p className="b-mono-dim ad-list-empty">no approvals data</p>
  }

  const stateCount = sport.approved_states.length
  const intlCount = sport.international.length

  return (
    <div className="ew-approvals">
      <div className="ew-section">
        <div className="ew-section-head">
          <span className="b-mono">UNITED STATES</span>
          <span className="b-mono-dim b-tiny">{stateCount} OF 51</span>
        </div>
        {stateCount === 0
          ? <p className="b-mono-dim ad-list-empty">none</p>
          : (
              <ul className="ew-pill-list">
                {sport.approved_states.map(code => (
                  <li key={code} className="ew-pill" title={code}>{stateName(code)}</li>
                ))}
              </ul>
            )}
      </div>

      <div className="ew-section">
        <div className="ew-section-head">
          <span className="b-mono">INTERNATIONAL</span>
          <span className="b-mono-dim b-tiny">{intlCount} REGION{intlCount === 1 ? '' : 'S'}</span>
        </div>
        {intlCount === 0
          ? <p className="b-mono-dim ad-list-empty">none</p>
          : (
              <ul className="ew-pill-list">
                {sport.international.map(region => (
                  <li key={region} className="ew-pill">{region}</li>
                ))}
              </ul>
            )}
      </div>
    </div>
  )
}
